import React from 'react';
import {
  TextInput
} from 'react-native';

import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as ht from './_ht';
import * as cr from './_cr';

import * as gs from './_csGbl';

import * as cmODT from './_cmODT';

import * as ica from 'src/ica';

import { a } from './_csAbt';
import { useMdlSchz } from './_csMdlSch';
import { useMdlPcrz } from './_csMdlPcr';
import { useMdlDtmz } from './_csMdlDtm';
import { useAny, useDz } from './_csLcl';

//import * as TextC from './_ccbTextC';
import * as BoxC from './_ccbBoxC';

export const S = React.memo((pz: ht.iptCz) => {

  const _sMdlPcrz = useMdlPcrz();
  const _sMdlSchz = useMdlSchz();
  const _sMdlDtmz = useMdlDtmz();
  const _sPfx = useAny('');
  const _sVle = useAny(null);

  React.useEffect(() => {
//hf.l(`Ipt 27: ${pz.cz?.bEdit}, ${_sPfx.crt}`);
    if (pz.cz?.vle || pz.cz?.vle == '' || pz.cz?.vle == 0) {
      if (pz.cz.iptType == 'text') {
        _sVle.set(pz.cz?.vle);
        _sPfx.set(pz.cz?.vle);
      }
      if (hf.i(pz.cz.iptType, ['pcr', 'sch'])) {
        _sVle.set(pz.cz?.vle);
        const _dz = hf.getDz(pz.cz?.ls ?? [], pz.cz?.vle, 'key') ?? ({} as ht.dz);
        _sPfx.set(_dz.pfx ?? '');
      }
      if (pz.cz.iptType == 'dtm') {
        _sVle.set(pz.cz?.vle);
        _sPfx.set(pz.cz?.vle);
      }
    }
    else { // 初期化に必要
      if (pz.cz.iptType == 'text') {
        _sVle.set('');
        _sPfx.set('');
      }
      if (hf.i(pz.cz.iptType, ['pcr', 'sch'])) {
        _sVle.set(-1);
        _sPfx.set('');
      }
      if (pz.cz.iptType == 'dtm') {
        _sVle.set('');
        _sPfx.set('');
      }
    }
  }, [
    pz.cz?.ls,
    pz.cz?.vle,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.iptAbtz[_abtType] ? ica.iptAbtz[_abtType]() : {};

  const _onChg = async (_vle: ht.n | ht.s | ht.dz) => {
/*
    const _gUserz = gs.useUserz();
    await _gUserz.saveAsync({ // wait しない, onPress のみ対象
      ornDtm: hfDTM.getNow()
    });
*/
    await cmODT.setAsync();
    if (pz.cz?.onChg) pz.cz?.onChg(_vle);
  };

  let _o = (
    cr.c(TextInput, {
      key: 'Ipt.root',
      editable: pz.cz?.bEdit != false ? true : false,
      disabledInputStyle: {
        opacity: 1,
        backgroundColor: 'transparent',
      },
      secureTextEntry: pz.cz?.bScr == true ? true : false,
      selectTextOnFocus: pz.cz?.bEdit != false ? true : false,
      autoComplete: 'off', // none: for web, off: for iphone / android
      style: {
        ... pz.cz?.bEdit == false ? _abtz.iptStlz?.showz : _abtz.iptStlz?.editz,
        ... pz.cz?.bEdit == false ? pz.iptStlz?.showz : pz.iptStlz?.editz,
      },
      value: 
        pz.cz?.bEdit == false ?
          pz.cz.grtPfx ? pz.cz.grtPfx(_sVle.crt) : _sPfx.crt
        : _sPfx.crt,
      onChangeText: (_s: ht.s) => {
        if (pz.cz.iptType == 'text') {
          _sPfx.set(_s);
          _sVle.set(_s);
          if (pz.cz.bDrt) _onChg(_s); // google password manager を反映する場合などに使用
        }
      },
      onBlur: () => {
        if (pz.cz.iptType == 'text') {
//          if (pz.cz?.onChg) pz.cz?.onChg(_sVle.crt);
          _onChg(_sVle.crt);
        }
      },
      onFocus: async () => {
        if (pz.cz?.bEdit == false) return; // 無反応
        if (pz.cz?.bfrFcsAsync) {
          const _b = await pz.cz?.bfrFcsAsync()
          if (!_b) return;
        }
        if (pz.cz.iptType == 'pcr') {
          _sMdlPcrz.show({
            ls: pz.cz?.ls,
            onPrs: (_dz: ht.dz) => {
              _sPfx.set(_dz.pfx);
              _sVle.set(_dz.key);
//              if (pz.cz?.onChg) pz.cz?.onChg(_dz);
              _onChg(_dz);
            },
          });
        } 
        if (pz.cz.iptType == 'sch') {
          _sMdlSchz.show({
            ls: pz.cz?.ls,
            onPrs: (_dz: ht.dz) => {
              _sPfx.set(_dz.pfx);
              _sVle.set(_dz.key);
              _onChg(_dz);
            },
          });
        } 
        if (pz.cz.iptType == 'dtm') {
          _sMdlDtmz.show({
            dtmz: {
              ... pz.cz?.dtmz,
              crt: hf.f(_sVle.crt) ? _sVle.crt : (pz.cz?.dtmz?.crt ?? ''),
            },
            onPrs: (_dtm: ht.s) => {
              _sPfx.set(_dtm);
              _sVle.set(_dtm);
//              if (pz.cz?.onChg) pz.cz?.onChg(_dtm);
              _onChg(_dtm);
            },
          });
        } 
      },
      ... _abtz.iptPtyz,
      ... pz.iptPtyz,
    })
  );

  if (
    hf.f(pz.boxStlz) || 
    hf.f(_abtz.boxStlz)
  ) { // Link への対応
    _o = (
      cr.c(BoxC.N, {
        key: 'Text.root',
        boxStlz: {
          ... _abtz.boxStlz,
          ... pz.boxStlz,
        },
        oClds: _o
      })
    );
  }

  return _o;
});

export const M = (pz: ht.iptMplCz) => { // multiple input

  const _sDz = useDz();
  React.useEffect(() => {
    if (pz.cz.dz) {
      _sDz.set(pz.cz.dz);
    }
  }, [
    pz.cz.dz
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.iptMplAbtz[_abtType] ? ica.iptMplAbtz[_abtType]() : ({} as ht.dz);

  return (
    cr.c(BoxC.N, {
      key: 'Ipt.M.root',
      boxz: {
        stlz: _abtz.boxz,
      },
      oClds: hf.getRng(pz.cz.nCnt).map( (_n: ht.n) => {
        const _onChg = ( _vle: ht.s ) => {
          const _dz = {
            ... _sDz.crt,
            [_n]: _vle,
          };
          _sDz.rlc(_dz);
          if (pz.cz.onChg) pz.cz.onChg(_dz);
        };
        return (
          cr.c(S, {
            key: _n,
            abtType: 'none',
            cz: {
              bEdit: pz.cz.bEdit,
              type: pz.cz.iptType,
              ls: pz.cz.ls,
              vle: _sDz.crt[_n],
              onChg: _onChg,
            },
            iptEditStlz: {
              ... _abtz.iptStlz?.editz,
              ... pz.iptStlz?.editz
            },
            iptShowStlz: {
              ... _abtz.iptStlz?.showz,
              ... pz.iptStlz?.showz
            },
            iptPtyz: {
              ... _abtz.iptPtyz,
              ... pz.iptPtyz
            },
          })
        )
      })
    })
  )
};